<div class="p-1">
  <div class="mat-elevation-z8">
    <div class="responsive-table scroll-container" [ngClass]="{ 'hide-scroll': !searchResults || loadingRecords }"
      tabindex="0" *ngIf="searchResults">
      <mat-table matSort class="tableLayout" (matSortChange)="sortData()" [dataSource]="dataSource">
        <ng-container *ngFor="let column of columns" [matColumnDef]="column.id" [sticky]="isSticky(column.id)"
          [stickyEnd]="isStickyEnd(column.id)">
          <mat-header-cell *matHeaderCellDef [mat-sort-header]="column.sortProperty"
            [disabled]="column.sortProperty ? false : true" [matTooltip]="column.tooltip ? column.tooltip : undefined"
            [matTooltipPosition]="'above'">
            <div style="display: flex; align-items: center" *ngIf="column.type !== 'select'">
              <ag-lock-column [ngClass]="{'ml-2': !isStickyEnd(column.id)}" [displayName]="column.name"
                [columnName]="column.id" [stickyColumns]="stickyColumns" [stickyEndColumns]="stickyEndColumns">
              </ag-lock-column>
            </div>
            <div style="display: flex; align-items: center; align-self: flex-start;" *ngIf="column.type === 'select'">
              <mat-checkbox (click)="$event.stopPropagation()" *appUserRole="buildGuardParamBasedRole()"
                (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" [attr.data-label]="column.name">
            <span *ngIf="column.type !== 'date' && column.type !== 'button' && column.type !=='select'">
              {{ column.processFunction ? column.processFunction(row[column.valueProperty], instance) :
              row[column.valueProperty] }}
            </span>
            <span *ngIf="column.type === 'date'">{{ row[column.valueProperty] | date: column.dateType ? column.dateType
              : 'MM/dd/yyyy HH:mm:ss.SSS'
              }}</span>
            <div *ngIf="column.type === 'button'">
              <button class="row-button" mat-raised-button color="primary" *appUserRole="buildGuardParamRole(column)"
                (click)="$event.stopPropagation(); doButtonClick(column.buttonAction, row);">
                <mat-icon *ngIf="column.buttonIcon"> {{ column.buttonIcon }} </mat-icon>
                <span *ngIf="column.buttonName"> {{ column.buttonName }} </span>
              </button>
            </div>
            <div *ngIf="column.type === 'select'">
              <mat-checkbox (click)="$event.stopPropagation()" *appUserRole="buildGuardParamBasedRole()"
                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [hidden]="loadingRecords"
          [ngClass]="{ 'highlight-selected': selection.isSelected(row), 'highlight-row': clickableRow ? clickableRow(row) : true, 'non-highlighted-row': clickableRow ? !clickableRow(row) : false }"
          (click)="clickableRow ? (clickableRow(row) ? onClick(row) : $event.preventDefault()) : $event.preventDefault()"></mat-row>
      </mat-table>
    </div>
    <div *ngIf="!searchResults" class="no-records">
      <span> No records found for the selected filters! </span>
    </div>
    <div *ngIf="loadingRecords" class="load-records">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>

    <mat-paginator #paginator [pageSizeOptions]="pageOptions" [length]="totalRows" showFirstLastButtons
      [style.display]="searchResults ? 'block' : 'none'">
    </mat-paginator>
  </div>
</div>